/* eslint-disable @typescript-eslint/no-unused-vars */
import "amazon-connect-streams";
import { createContext } from "react";

export interface IContactDict {
    [name: string]: IContactItem;
}
export interface IContactItem {
    contactId: string;
    contactState: connect.ContactStateType;
    contactType: connect.ContactType;
    connectionType: connect.ConnectionStateType;
    showWorkflow: boolean;
    workflowURL: string;
    screenPopURL: string;
    agentSupportURL: string;
    attributes: {
        [key: string]: {
            name: string;
            value: string;
        };
    };
}
/**
 * Provides shared features to the app
 */
export interface ICallContext {
    contact: connect.Contact | undefined;
    contactDict: IContactDict;
    agent: connect.Agent | undefined;
    setContact: (_contact: connect.Contact | undefined) => void;
    setAgent: (_agent: connect.Agent | undefined) => void;
}

const CallContext = createContext<ICallContext>(null as any);

export { CallContext };
